import { style } from 'typestyle'
export const pb16 = style({ paddingBottom: '16px' })
